import api from "../../services/api";
import { QueueEntry } from "./types";

// ✅ Fetch queue entries for a specific business
export const fetchQueueAPI = async (businessId: string): Promise<QueueEntry[]> => {
  const response = await api.get<QueueEntry[]>(`/queue/${businessId}`);
  return response.data;
};

// ✅ Join a queue
export const joinQueueAPI = async (businessId: string): Promise<QueueEntry> => {
  const response = await api.post<QueueEntry>(`/queue/join`, { businessId });
  return response.data;
};

// ✅ Leave a queue (no response expected)
export const leaveQueueAPI = async (queueId: string): Promise<void> => {
  await api.post(`/queue/leave`, { queueId });
};
